import {
  AfterViewInit,
  Component,
  ElementRef,
  Injectable,
  ViewChild,
} from '@angular/core';
// declare let hotjar: any;
import { environment } from '../../../environments/environment';

@Component({
  selector: 'mj-hotjar',
  template: `
    <div #hotjarScript style.display="none">
      <ng-content></ng-content>
    </div>
  `,
})
export class HotjarComponent implements AfterViewInit {
  @ViewChild('hotjarScript', { static: true }) script: ElementRef;

  constructor() {}

  public ngAfterViewInit() {
    if (!window['_hjSettings']) {
      window['_hjSettings'] = {
        hjid: environment.hotjarId,
        hjsv: environment.hotjarVersion,
      };
    }

    this.convertToScript();
  }

  protected getSrc(): string {
    return `//static.hotjar.com/c/hotjar-${environment.hotjarId}.js?sv=${environment.hotjarVersion}`;
  }

  protected convertToScript() {
    const element = this.script.nativeElement;
    const parent = element.parentElement;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.getSrc();

    parent.parentElement.replaceChild(script, parent);
  }
}

export interface HotjarConfig {
  version: string;
  trackingId: string;
}
export interface HotjarConfigMap {
  [id: string]: HotjarConfig;
}

@Injectable()
export class HotjarService {
  constructor() {
    if (!window['_hjSettings'] && environment.hotjarId) {
      window['_hjSettings'] = {
        hjid: environment.hotjarId,
        hjsv: environment.hotjarVersion,
      };
    }
  }
  public getInstance() {
    return (window['hj'] = window['hj'] || this.getHotjarQueue());
  }

  public vpv(eventName: String) {
    // Virtual pageviews
    this.getInstance()('vpv', eventName);
  }

  public trigger(eventName: string) {
    this.getInstance()('trigger', eventName);
  }
  private getHotjarQueue() {
    return function() {
      // console.log('..:: HOTJAR EVENT PUSHED IN QUEUE ::..', arguments);
      (window['hj']['q'] = window['hj']['q'] || []).push(arguments);
    };
  }
}
